var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPostingFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Posting",
    transform: "translate(-377 -1024)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 24,
    height: 24,
    transform: "translate(377 1024)",
    fill: "#347af0",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Posting-2",
    "data-name": "Posting",
    transform: "translate(379 1026)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1109",
    "data-name": "Group 1109",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3307",
    "data-name": "Path 3307",
    d: "M66.139,0a10.063,10.063,0,0,0-6.046,2.039l.083-.839-1.281-.127-.247,2.492a.652.652,0,0,0,.641.707h2.472V2.984h-.784A8.71,8.71,0,0,1,74.851,10c0,.271-.013.544-.037.812l1.282.118c.028-.307.043-.62.043-.931A10.094,10.094,0,0,0,66.139,0Z",
    transform: "translate(-56.139)",
    fill: "#347af0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3308",
    "data-name": "Path 3308",
    d: "M34.978,341.931a10.069,10.069,0,0,0,.921,1.256l.976-.84a8.773,8.773,0,0,1-.8-1.095Z",
    transform: "translate(-33.483 -326.67)",
    fill: "#347af0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3309",
    "data-name": "Path 3309",
    d: "M144.3,423.551a9.957,9.957,0,0,0,1.482.483l.3-1.252a8.674,8.674,0,0,1-1.289-.42Z",
    transform: "translate(-138.132 -404.312)",
    fill: "#347af0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3310",
    "data-name": "Path 3310",
    d: "M8.018,282.887l-1.25.308a9.951,9.951,0,0,0,.49,1.48l1.187-.5A8.677,8.677,0,0,1,8.018,282.887Z",
    transform: "translate(-6.479 -270.798)",
    fill: "#347af0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3311",
    "data-name": "Path 3311",
    d: "M1.309,217.79.024,217.7a10.134,10.134,0,0,0,.013,1.556l1.283-.109A8.855,8.855,0,0,1,1.309,217.79Z",
    transform: "translate(0 -208.398)",
    fill: "#347af0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3312",
    "data-name": "Path 3312",
    d: "M7.546,147.311l-1.195-.48a9.963,9.963,0,0,0-.466,1.487l1.255.287A8.673,8.673,0,0,1,7.546,147.311Z",
    transform: "translate(-5.634 -140.556)",
    fill: "#347af0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3313",
    "data-name": "Path 3313",
    d: "M82.36,390.264a10.065,10.065,0,0,0,1.26.915l.673-1.1a8.767,8.767,0,0,1-1.1-.8Z",
    transform: "translate(-78.84 -372.648)",
    fill: "#347af0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3314",
    "data-name": "Path 3314",
    d: "M421.432,285.58l1.183.508a9.961,9.961,0,0,0,.5-1.476l-1.248-.317A8.665,8.665,0,0,1,421.432,285.58Z",
    transform: "translate(-403.422 -272.147)",
    fill: "#347af0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3315",
    "data-name": "Path 3315",
    d: "M387.717,343.533l.97.846a10.06,10.06,0,0,0,.929-1.249l-1.09-.686A8.764,8.764,0,0,1,387.717,343.533Z",
    transform: "translate(-371.148 -327.81)",
    fill: "#347af0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3316",
    "data-name": "Path 3316",
    d: "M215.065,437.2l-.1,1.283a10.136,10.136,0,0,0,1.556.005l-.094-1.284A8.907,8.907,0,0,1,215.065,437.2Z",
    transform: "translate(-205.776 -418.52)",
    fill: "#347af0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3317",
    "data-name": "Path 3317",
    d: "M280.556,423.318l.293,1.254a9.965,9.965,0,0,0,1.486-.473l-.485-1.193A8.66,8.66,0,0,1,280.556,423.318Z",
    transform: "translate(-268.566 -404.834)",
    fill: "#347af0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3318",
    "data-name": "Path 3318",
    d: "M339.207,390.972l.665,1.1a10.058,10.058,0,0,0,1.267-.906l-.828-.986A8.771,8.771,0,0,1,339.207,390.972Z",
    transform: "translate(-324.711 -373.508)",
    fill: "#347af0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3319",
    "data-name": "Path 3319",
    d: "M114.791,109.468a5.322,5.322,0,1,0,5.322,5.322A5.322,5.322,0,0,0,114.791,109.468Zm.6,8v.889h-1.209v-.817a2.66,2.66,0,0,1-1.246-.544l.433-1.228a2.213,2.213,0,0,0,1.291.534c.335,0,.551-.155.551-.395,0-.167-.078-.353-.641-.585-.738-.294-1.493-.724-1.493-1.69a1.592,1.592,0,0,1,1.16-1.546v-.865h1.2v.789a2.9,2.9,0,0,1,1.084.448l-.452,1.209a2.22,2.22,0,0,0-1.156-.43c-.287,0-.452.11-.452.3,0,.146.051.263.728.547.978.4,1.415.95,1.415,1.767A1.688,1.688,0,0,1,115.392,117.468Z",
    transform: "translate(-104.791 -104.79)",
    fill: "#347af0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostingFill);
export default __webpack_public_path__ + "static/media/postingFill.7a01c26fac87b0adae5fb9e11b86a01a.svg";
export { ForwardRef as ReactComponent };